"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../util");
var error_1 = require("../error");
// Writes a resource to URL string
var toRetrieveUrl = function (options, id) {
    return [
        options.client.url(),
        options.resource,
        encodeURIComponent(id),
        options.action,
    ]
        .filter(function (e) { return e !== undefined; })
        .join("/");
};
exports.retrieveMethod = function (options) {
    var client = options.client;
    return function (id, request) {
        return client.agent
            .http({
            method: "GET",
            url: toRetrieveUrl(options, id),
            query: util_1.toStringMap(request.query),
            header: util_1.toHeader(request, client),
            timeout: util_1.toTimeout(request, client),
        })
            .then(function (response) {
            var error = error_1.parse(response);
            if (error)
                throw error;
            return response;
        });
    };
};
exports.listMethod = function (options) {
    var client = options.client, resource = options.resource;
    return function (request) {
        return client.agent
            .http({
            method: "GET",
            url: client.url() + "/" + resource,
            query: util_1.toStringMap(request.query),
            header: util_1.toHeader(request, client),
            timeout: util_1.toTimeout(request, client),
        })
            .then(function (response) {
            var error = error_1.parse(response);
            if (error)
                throw error;
            return response;
        });
    };
};
//# sourceMappingURL=resource.js.map